 <section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Orders</li>
    </ol>
  </nav>

  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage2">{{errorMessage2}}</div>

  <div
    *ngIf=" ((totalRecords > 0) && ( user.role === 'ROLE_USER' || user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'))">
    <div class="row align-items-center">
      <div class="col-4"
           *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER')">
        <ul class="list-inline tab-list">
          <div id="statusText1" class="invalid-feedback d-block" [hidden]="!statusText1">{{statusText1}}</div>
        </ul>
      </div>
    </div>
  </div>

  <!--<div class="row">
    <div class="col">
      <div class="inner-box no-listbox">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-right">
            <img src="assets/images/Emptyscreen - Orders.png">
          </div>
          <div class="col-md-6">
            <h2>Be the one to start</h2>
            <h1 class="f-46 text-orange">Create your first Order!!</h1>
            <a (click)="submitOrder()"
               *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER' && accessSec.createOrder)">
              <button class="btn btn-orange-prime mt-4">Create now</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>-->

  <div>

    <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>

    <div class="row align-items-center">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus);resetCheckedList(); tabChange()"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
          <li class="list-inline-item">
            <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of ordersMainMenu">
                <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                   (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                   [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>

        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of ordersMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
        </select>
      </div>
      <div class="col text-right">

        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
                *ngIf="tabClicked !== 'all'">
          Actions
        </button>

        <a placement="bottom" class="ml-2" ngbTooltip="Export To Excel" style="text-align-last: center;">
          <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
               viewBox="0 0 30 30">
            <defs>
              <style>.a {
                fill: #8a55bb !important;
              }
              .b {
                fill: #fff;
              }

              </style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                    transform="translate(3.386 5.171)"/>
            </g>
          </svg>
        </a>

        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"

             *ngIf="(checkedList2?.length) && tabClicked !== 'all'">
          <a *ngIf="tabClicked === 'submitted'" [ngClass]="{'disabled':disableAction('processing order')}"
             (click)="processingOrder(orders)" class="dropdown-item file btn shift-import">Process Order</a>
          <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('processing')}"
             (click)="processingOrder(orders)" class="dropdown-item file btn shift-import">Process Order</a>
          <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('submitted')}"
             (click)="generateShippingLabel(orders)" class="dropdown-item file btn shift-import">Generate Shipping
            Label</a>
          <a *ngIf="tabClicked === 'InProcess'" [ngClass]="{'disabled':disableAction('labelGenerated')}"
             (click)="generateManifest(checkedOrderIdList)" class="dropdown-item file btn shift-import">Generate
            Manifest</a>
          <a *ngIf="tabClicked === 'submitted' || tabClicked === 'InProcess' || tabClicked === 'readyToShip'"
             (click)="cancelOrderPopUp(orders)"
             class="dropdown-item file btn shift-import">Cancel Order</a>
          <a *ngIf="tabClicked === 'submitted' || tabClicked === 'InProcess'" (click)="openActionPopup('markAsAnHold')"
             class="dropdown-item file btn shift-import">Mark as On Hold</a>
          <a *ngIf="tabClicked === 'onHold'" (click)="openActionPopup('unHoldOrder')"
             class="dropdown-item file btn shift-import">Unhold Order</a>
          <a *ngIf="tabClicked === 'readyToShip'" (click)="reassignShipment()"
             class="dropdown-item file btn shift-import">Reassign Shipment</a>
          <a *ngIf="tabClicked === 'Delivered'" class="dropdown-item file btn shift-import"
             (click)="returnOrders(orders)">Return Order</a>
        </div>
        <a placement="bottom" ngbTooltip="Sync Orders" class="ml-2">
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg" (click)="syncOrders()"
               width="30" height="30" viewBox="0 0 512.000000 512.000000"
               preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
               fill="#8a55bb" stroke="none">
              <path d="M2478 4869 c-55 -8 -99 -33 -145 -81 -17 -18 -133 -161 -257 -318
                -257 -323 -270 -346 -269 -475 1 -171 24 -200 406 -506 340 -272 365 -286 463
                -276 140 14 234 119 234 259 0 113 -32 159 -200 290 -19 15 -31 30 -28 34 11
                10 229 -14 313 -36 193 -49 363 -143 507 -280 148 -139 240 -277 302 -450 51
                -145 69 -246 70 -395 0 -259 -62 -459 -214 -685 -31 -47 -62 -100 -69 -119
                -56 -169 95 -357 274 -338 99 10 159 57 255 201 281 421 355 965 198 1456
                -140 441 -474 816 -900 1014 -216 100 -460 155 -691 156 l-99 0 51 63 c77 94
                104 151 105 222 1 81 -24 144 -80 194 -66 62 -135 83 -226 70z"/>
              <path d="M1210 3621 c-76 -24 -123 -67 -210 -196 -280 -416 -355 -962 -198
                -1455 141 -442 471 -814 900 -1014 213 -99 466 -156 696 -156 l94 0 -51 -62
                c-104 -128 -129 -222 -88 -330 20 -52 89 -121 142 -144 51 -21 160 -18 210 6
                57 28 94 69 344 385 248 313 264 341 265 465 1 84 -19 148 -66 218 -19 28
                -141 133 -341 293 -263 210 -321 252 -366 265 -95 28 -190 3 -261 -68 -49 -48
                -70 -102 -70 -179 0 -99 33 -156 140 -243 47 -38 87 -73 89 -78 4 -13 -132 -3
                -248 18 -459 82 -825 446 -927 923 -21 96 -23 319 -5 421 30 166 96 324 201
                480 64 95 80 134 80 195 0 109 -80 219 -181 249 -56 17 -108 19 -149 7z"/>
            </g>
          </svg>

          <!--<svg xmlns="http://www.w3.org/2000/svg" (click)="syncOrders()" width="30" height="30" viewBox="0 0 30 30">
            <defs>
              <style>.a{fill:#8a55bb;}.b{fill:#fff;}</style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                    transform="translate(2.823 3.938)"/>
            </g>
          </svg>-->
        </a>

        <a placement="bottom" ngbTooltip="Create" class="ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" (click)="submitOrder()" width="30" height="30" viewBox="0 0 30 30">
            <defs>
              <style>.a {
                fill: #8a55bb;
              }

              .b {
                fill: #fff;
              }

              </style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                    transform="translate(2.823 3.938)"/>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>

   <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
        <table id="tables_id" class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" width="100%">
          <thead>
          <tr>
            <th></th>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th>Order Date</th>
            <th>Age of Order</th>
            <th
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              Sender name / CompanyName
            </th>
            <th>Channel / Source</th>
            <th [hidden]="tabClicked !=='onHold'">NoOf Days Hold</th>
            <th>Order Amount</th>
            <th
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              Customer Name
            </th>
            <th
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              Customer City
            </th>
            <th>Payment Method</th>
            <th *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">Carrier Name</th>
            <th *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">AWB #</th>
            <th>Status</th>
            <th></th>
            <th [hidden] ="tabClicked !== 'Delivered'">Return</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td>
              <div class="form-checkbox"
                   *ngIf="tabClicked == 'submitted' || tabClicked == 'onHold' || tabClicked == 'readyToShip' || tabClicked == 'InProcess'">
                <input
                  type="checkbox" id="{{o.orderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                  (change)="selectShip(o)">
                <label for="{{o.orderHeaderId}}"></label></div>
            </td>
            <td><a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></td>
            <td>{{o.sourceOrderId || '--'}}</td>
            <td>{{(o.createdDate) | date: 'dd-MMM-yyyy'}}</td>
            <td>{{o.ageOfOrder | dateAgo}}</td>
            <td
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              {{o.senderName}} / {{o.senderCompanyName || '--'}}
            </td>
            <td>{{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | replaceStatus}}</td>
            <td [hidden]="tabClicked !=='onHold'">
              <div *ngIf="o.noOfDaysOnHold !=null">
                {{o.noOfDaysOnHold}} {{'ago'}}
              </div>
            </td>
            <td>{{o.orderAmount}}</td>
            <td
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              {{o.receiverName}}
            </td>
            <td
              [hidden]="tabClicked == 'onHold' || tabClicked == 'Delivered' || tabClicked == 'Cancelled' || tabClicked == 'RTO'">
              {{o.receiverCity}}
            </td>
            <td>{{(o?.paymentMethod == 'COD' ? 'Cash On Delivery' : (o?.paymentMethod | replaceStatus)) || '--'}}<span
              *ngIf="o?.remittanceDate !== ''"><img src="/./assets/images/tick.svg"
                                                      style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"></span>
            </td>
            <td
              *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">{{(o.shippingOption
              == 'SD' ? 'Shift' :
              (o.shippingOption == 'DL' ? 'Delhivery' :
              (o.shippingOption == 'GT' ? 'Gati' :
              (o.shippingOption == 'DZ' ? 'Dotzot' :
              (o.shippingOption == 'RD' ? 'Rapid Delivery' :
              (o.shippingOption == 'SF' ? 'Shadow Fax' :
              (o.shippingOption == 'BD' ? 'Blue Dart' :
              (o.shippingOption == 'PR' ? 'Pickrr' :
              (o.shippingOption == 'SY' ? 'Ship Yaari' :
              (o.shippingOption == 'DE' ? 'Delhivery' :
              (o.shippingOption == 'SG' ? 'Shippigo' :
              (o.shippingOption == 'VS' ? 'Vamaship' :
              (o.shippingOption == 'DN' ? 'Dunzo' :
              (o.shippingOption == 'WF' ? 'Borzo' :
              (o.shippingOption == 'KE' ? 'Kerry Express' :
              (o.shippingOption == 'XB' ? 'Xpressbees' :
              (o.shippingOption == 'EE' ? 'Ecom Xpress' :
              (o.shippingOption == 'FE' ? 'FedEx' : o.shippingOption))))))))))))))))))}}
            </td>
            <td
              *ngIf="tabClicked == 'all' || tabClicked == 'readyToShip' || tabClicked == 'shipped'">
              {{o.thirdPartyTrackingNum}}
            </td>
            <td>
              <div class="text-truncate" title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Awaiting Pickup':
                (o.orderStatus == 'SHIPPED' ? 'Shipped':
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus ))))) | replaceStatus}}"
                   style="width:100px;">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be Assigned' :
                (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus))))) | replaceStatus}}
              </div>
            </td>
            <td>
              <div
                *ngIf="o.thirdPartyTrackingNum !== null && (o.orderStatus == 'SHIPPED' || o.orderStatus == 'AWAITING_CARRIER')">
                <a routerLink="/trackOutboundOrder/{{o.orderHeaderId}}/{{o.accountOwnerId}}" target="_blank">
                  <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                </a>
              </div>
            </td>
            <td style="width:160px" [hidden] ="tabClicked !== 'Delivered'"><button routerLink="/admin/createReturnManually/{{o.orderNumber}}" style="width:160px;border:1px solid white;border-radius:10px; padding:4px;">Arrange return</button></td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0 || !orders?.length">
            <td colspan="10" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none ">
        <table id="Table_id" class="table tablesaw tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th width="200px;" style="width: 0px!important;">Order Date</th>
            <th>Channel / Source</th>
            <th width="200px;">Contact</th>
            <th>City</th>
            <th style="width: 102px;">Age of Order</th>
            <th *ngIf="user.role==='ACCOUNT_OWNER'" style="width:110px!important;">Payment Method</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td>
              <b class=" tablesaw-cell-label">Order #</b>
              <span class="tablesaw-cell-content">
                 <a routerLink="/admin/viewOrders/{{o.orderHeaderId}}"
                    [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editOrder)}">{{o.orderNumber}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Source Order</b><span
              class="tablesaw-cell-content"> {{o.sourceOrderId || '--'}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Source Data</b><span
              class="tablesaw-cell-content">  {{(o.createdDate) | date: 'dd-MMM-yyyy'}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Channel Name</b>
              <span
                class="tablesaw-cell-content"> {{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | titlecase}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Contact Name</b>
              <span
                class="tablesaw-cell-content">  {{o.contactCompanyName ? (o.contactCompanyName + '-') : ''}}{{o.contactName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">City</b>
              <span class="tablesaw-cell-content">{{o.contactCity  | replaceStatus}}</span></td>
            <td><b class=" tablesaw-cell-label">Age Of Address</b>
              <span class="tablesaw-cell-content">{{o.noOfDaysOnHold}}</span></td>
            <td *ngIf="user.role==='ACCOUNT_OWNER'"><b class=" tablesaw-cell-label">Payment Method</b>
              <span class="tablesaw-cell-content">{{(o?.paymentMethod|replaceStatus) || '--'}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
                <div class="text-truncate" title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                  (o.orderStatus == 'SHIPPED' ? 'Shipped':
                  (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                  (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                  (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                  (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus )))))) |replaceStatus}}"
                     style="width:100px;">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                  (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                    (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                      (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                        (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                          (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus)))))) |replaceStatus}}
                </div>
              </span>
            </td>
          </tr>
          </tbody>

        </table>
      </div>
    </div>
  </div>
</section>

<!--Tracking Details popup-->
<div class="modal fade" id="orderDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <h2 class="modal-title">Tracking Details</h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div [hidden]="awb.tracking_data.error==null">
              <label class="text-black"><b>Info :</b><span class="ml-1">{{awb.tracking_data.error}}</span></label><br>
            </div>
            <div [hidden]="awb.tracking_data.error!=null">
              <label class="text-black"
                     *ngFor="let s of awb.tracking_data.shipment_track_activities"><b>Activity:</b><span
                class="ml-1">{{s.activity}}</span></label><br>
              <div *ngFor="let s of awb.tracking_data.shipment_track">
                <label class="text-black"><b> Delivered to :</b><span class="ml-1">{{s.delivered_to}}</span></label><br>
                <label class="text-black"><b>Status :</b><span class="ml-1"></span>{{s.current_status}}</label><br>
              </div>
              <label class="text-black"><b>Estimated Delivery date :</b><span
                class="ml-1">{{awb.tracking_data.edd | date : "dd-MMM-yyyy"}}</span></label>
            </div>
          </div>
        </div>
      </div>
      <!--Footer-->
    </div>
  </div>
</div>

<div [ngStyle]="{'display': cancelActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': cancelActivities == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Cancel Order</h5>
        <button type="button" class="close" (click)="closepopUpRequest()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class=" form-group">
                  <label class="control-label" for="cancelReason">Cancel Reason</label>
                  <select id="cancelReason" class="form-control" [(ngModel)]="reason"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let c of cancelReasons" [ngValue]="c.config">{{c.config}}</option>
                  </select>
                  <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!cancelError">
                    {{cancelError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closepopUpRequest()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="cancelMultiOrders(orders)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': holdActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': holdActivities == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Orders to put on Hold</h5>
        <button type="button" class="close" (click)="closepopUpRequest()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="d-none d-sm-block">
                <div calss="row">
                  <div calss="col">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>Channel Order #</th>
                        <th>Order Date</th>
                        <th>Contact</th>
                        <th>Warehouse</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let l of checkedListView;let i=index">
                        <td>{{l.sourceOrderId}}</td>
                        <td>{{l.orderedDate}}</td>
                        <td style="text-transform:capitalize;">{{l.contactCompanyName}}-{{l.contactName}}</td>
                        <td>{{l.warehouseName}}</td>
                        <td>
                          <a (click)="splice(i,l.orderHeaderId)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                              <defs>
                                <style>.a {
                                  fill: #848484;
                                }



                                </style>
                              </defs>
                              <path class="a"
                                    d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                    transform="translate(-7.5 -4.5)"/>
                            </svg>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <label class="control-label" for="hold">Hold Reason</label>
                  <div class="form-group mt-2">
                    <textarea type="text" id="hold" [(ngModel)]="activityDetails" class="form-control"
                              [ngModelOptions]="{standalone: true}" required></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closepopUpRequest()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="holdMultiOrders(orders)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': orderActionPopup == 'Y'}" [ngStyle]="{'display': orderActionPopup  =='Y'? 'block' : 'none'}"
     style="overflow-y:auto" class="modal fade show" id="exampleModal" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true" style="padding-top:100px;">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="closepopUpRequest()">&times;</button>
      </div>
      <div class="modal-body">
        <label *ngIf="selection === 'markAsAnHold'" class="mb-3">Do you want hold the Order? </label>
        <label *ngIf="selection === 'unHoldOrder'" class="mb-3">Do you want to UnHoldOrder? </label>
      </div>
      <div class="modal-footer">
        <button (click)="closepopUpRequest()" class="btn btn-cancel" type="button">No</button>
        <button (click)="openSelectionPopup()" *ngIf="selection === 'markAsAnHold'"
                class="btn icon-left btn-orange-primary ml-3"
                type="button">Yes
        </button>
        <button (click)="openSelectionPopup()" *ngIf="selection === 'unHoldOrder'"
                class="btn icon-left btn-orange-primary ml-3"
                type="button">Yes
        </button>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': returnPopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': returnPopUp == 'Y'}" class="modal" id="returnPopUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="returnChoseReason">Choose Return Reason</h5>
        <button type="button" class="close" (click)="closepopUpRequest()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <select id="returnReason" class="form-control" [(ngModel)]="reason"
                      [ngModelOptions]="{standalone: true}" required>
                <option *ngFor="let r of returnReasons" [ngValue]="r.config">{{r.config}}</option>
              </select>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!reasonError">
                {{reasonError}}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closepopUpRequest()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="submitReturnOrder()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

